export default __webpack_public_path__ + "static/media/LaneProductDistribution.4353fbe5.jpg";